import { FlyoutDrsFileInfoGeneric } from "components/FlyoutDrsFileInfo/FlyoutDrsFileInfoGeneric";
import { RightFlyoutContent } from "../store/DataTableProvider.types";
import { FlyoutTableDescription } from "components/FlyoutTableDescription/FlyoutTableDescription";

interface DataTableFlyoutRightProps {
  content: RightFlyoutContent;
  fileId?: string;
  onClose: () => void;
}

/** Component that renders a right-side flyout for a data table */
export const DataTableFlyoutRight = ({
  content,
  fileId,
  onClose,
}: DataTableFlyoutRightProps) => {
  if (content === "fileInfo" && fileId !== undefined) {
    return (
      <FlyoutDrsFileInfoGeneric drsFile={{ id: fileId }} onClose={onClose} />
    );
  }
  if (content === "tableDescription") {
    return <FlyoutTableDescription onClose={onClose} />;
  }
  return null;
};
